import React from 'react';
import { createRoot } from 'react-dom/client';
import ServerQueues from './ServerQueues';
import type { ServerQueuesProps, ServerQueuesHandle } from './types';

declare global {
  interface Window {
    mountServerQueues: (
      containerId: string,
      props: ServerQueuesProps,
    ) => ServerQueuesHandle;
  }
}

window.mountServerQueues = function mountServerQueues(
  containerId: string,
  props: ServerQueuesProps,
): ServerQueuesHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('ServerQueues: container not found:', containerId);
    return { type: 'server-queues', unmount: () => {} };
  }

  const root = createRoot(container);
  root.render(React.createElement(ServerQueues, props));

  return {
    type: 'server-queues',
    unmount: () => root.unmount(),
  };
};

export type {
  JobStatusItem,
  QueueStatus,
  QueuesResponse,
  QueueJob,
  QueueSectionVariant,
  ServerQueuesProps,
  ServerQueuesHandle,
} from './types';
